// navigation.js

$(document).ready(function() {
  // initial height of header container
  var headerFullHeight = $('.l-header-full').height();
  var headerCollapsedHeight = $('.l-header-full').height();

  // scrolling selectors
  // var inviewMain = $('#js_inview_main');
  // var scrollMain = $('#js_top_main');

  // remove the navigation > li 'init' class on inital load
  if (Foundation.MediaQuery.current === 'xs' ||
    Foundation.MediaQuery.current === 's') {
    headerFullHeight = $('.l-header-full').height();
    $('#js_navigation > li:not(:first)').addClass('hide').removeClass('init');
    headerCollapsedHeight = $('.l-header-full').height();
  } else {
    $('#js_navigation > li:not(:first)').addClass('show').removeClass('init');
  }

  // when a mediaquery change is triggered:
  // remove 'hide' when mq equals atleast 'm' (bigger screens)
  // add 'hide' when on a 'xs' || 's' screen
  $(window).on('changed.zf.mediaquery', function(event, name) {
    if (Foundation.MediaQuery.atLeast('m')) {
      headerFullHeight = $('.l-header-full').height();
      $('#js_navigation > li:not(:first)').addClass('show').removeClass('hide');
      headerCollapsedHeight = $('.l-header-full').height();
    } else {
      $('#js_navigation > li:not(:first)').addClass('hide').removeClass('show');
    }
  });

  // when we change the device orientation (landscape, portrait)
  // re-assign header_full_height
  // when on a 'xs' ||
  // 's' screen collapse the menu and re-assign header_collapsed_height
  $(window).bind('orientationchange', function(event) {
    if (Foundation.MediaQuery.current === 'xs' ||
      Foundation.MediaQuery.current === 's') {
      headerFullHeight = $('.l-header-full').height();
      $('#js_navigation > li:not(:first)').addClass('hide').removeClass('init');
      headerCollapsedHeight = $('.l-header-full').height();
    } else {
      headerFullHeight = $('.l-header-full').height();
    }

    /*
    switch(window.orientation) {
      case -90:
      case 90:
        alert('landscape');
        break;
      default:
        alert('portrait');
      break;
    }
    */
  });

  // scrolling functionality
  $(window).scroll(function(e) {
    // var y = $(document).scrollTop();
    // var h = $(window).height();

    // hide navigation > li items
    // re-assign: headerCollapsedHeight for 'xs' and 's'
    if (Foundation.MediaQuery.current === 'xs' ||
      Foundation.MediaQuery.current === 's') {
      $('#js_navigation > li:not(:first)').addClass('hide').removeClass('show');
      headerCollapsedHeight = $('.l-header-full').height();
    }
  });

  // scroll up
  $('[id^=\'js_top_\']').click(function(event) {
    // eslint-disable-next-line no-invalid-this
    var top = $(this.hash).offset().top;
    // eslint-disable-next-line no-invalid-this
    $(this.blur());
    event.preventDefault();
    $('html, body').animate({scrollTop: (top)}, 500);
  });

  // scroll down
  $('#js_navigation > li > a').click(function(event) {
    // eslint-disable-next-line no-invalid-this
    var down = $(this.hash).offset().top;
    // eslint-disable-next-line no-invalid-this
    $(this.blur());
    event.preventDefault();

    if (Foundation.MediaQuery.current === 'xs' ||
      Foundation.MediaQuery.current === 's') {
      // eslint-disable-next-line no-invalid-this
      if ($(this).prop('hash') ===
        $('#js_navigation > li:first > a').prop('hash')) {
        // toggle first navigation > li items
        // re-assign: headerFullHeight && headerCollapsedHeight
        headerFullHeight = $('.l-header-full').height();
        $('#js_navigation > li:not(:first)')
          .toggleClass('show')
          .toggleClass('hide');
        headerCollapsedHeight = $('.l-header-full').height();
      } else {
        // when we have header-sticky
        if ($('.l-header-full').hasClass('header-sticky')) {
          $('html, body').animate({
            scrollTop: (down - headerFullHeight),
          }, 500);
        } else {
          $('html, body').animate({
            scrollTop: (down - headerCollapsedHeight),
          }, 500);
        }
      }
    } else {
      $('html, body').animate({scrollTop: (down - headerFullHeight)}, 500);
    }
  });
});

//
// EOF
//
